import { createSelector, createSlice } from '@reduxjs/toolkit';
import { find, get, has, transform } from 'lodash';
import { bookingScheduleApi } from 'src/api/booking-schedule-api';
import { carApi } from 'src/api/car-api';
import { listPageConfig } from 'src/config';
export const bookingScheduleAsignCarTabs = {
  bookingFindCar: {
    label: 'Tìm xe',
    value: 'bookingFindCar'
  },
  bookingInfo: {
    label: 'Thông tin kèo',
    value: 'bookingInfo'
  }
};
const initialState = {
  pageState: {
    viewGroup: false,

    page: 0,
    rowsPerPage: listPageConfig.rowPerpage,
    filters: {
      query: '',
      status: []
    },
    sortBy: 'createdAt',
    sortDir: 'desc'
  },
  asignCarTab: bookingScheduleAsignCarTabs.bookingFindCar.value,
  curBookingScheduleCheckAvailableCars: {},

  bookingScheduleSelected: null
};

export const bookingScheduleSlice = createSlice({
  name: 'bookingSchedule',
  initialState,
  reducers: {
    resetState: () => initialState,
    resetPageState: (state) => {
      state.pageState = initialState.pageState;
    },

    changeFilters: (state, action) => {
      state.pageState.filters = { ...state.pageState.filters, ...action.payload };
    },
    changePageState: (state, action) => {
      state.pageState = { ...state.pageState, ...action.payload };
    },
    changeViewGroup: (state, action) => {
      state.pageState.viewGroup = action.payload;
    },
    changeOnlyPartnerBooking: (state, action) => {
      state.pageState.onlyPartnerBooking = action.payload;
    },
    changeAsignCarTab: (state, action) => {
      state.asignCarTab = action.payload;
    },

    setBookingScheduleSelected: (state, action) => {
      state.bookingScheduleSelected = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(carApi.endpoints.getWithCheckAvailableCars.matchFulfilled, (state, action) => {
      const result = transform(
        action.payload,
        (result, car) => {
          result[car.id] = car.availableForBooking;
        },
        {}
      );
      state.curBookingScheduleCheckAvailableCars = result;
    });
    builder.addMatcher(bookingScheduleApi.endpoints.getBookingSchedules.matchFulfilled, (state, action) => {
      if (has(state.bookingScheduleSelected, 'id')) {
        const bookingSchedule = find(action.payload, ['id', state.bookingScheduleSelected.id]);
        state.bookingScheduleSelected = bookingSchedule;
      }
    });
  }
});

// Action creators are generated for each case reducer function
export const {
  resetState,
  resetPageState,
  changeFilters,
  changePageState,
  changeViewGroup,
  changeOnlyPartnerBooking,
  changeAsignCarTab,

  setBookingScheduleSelected
} = bookingScheduleSlice.actions;

// Selectors
export const selectBookingScheduleSelected = ({ bookingSchedule }) => bookingSchedule.bookingScheduleSelected;
export const selectBookingScheduleCheckAvailableCars = ({ bookingSchedule }) => bookingSchedule.curBookingScheduleCheckAvailableCars;
export const selectBookingScheduleCheckAvailableCar = createSelector(
  [selectBookingScheduleCheckAvailableCars, (_state, carId) => carId],
  (curBookingScheduleCheckAvailableCars, carId) => get(curBookingScheduleCheckAvailableCars, carId)
);

export const selectBookingSchedulePageState = ({ bookingSchedule }) => bookingSchedule.pageState;

export const selectBookingSchedulePageStateTab = ({ bookingSchedule }) => bookingSchedule.pageState.tab;
export const selectBookingSchedulePageStateViewOnlyPartner = ({ bookingSchedule }) => bookingSchedule.pageState.onlyPartnerBooking;
export const selectBookingSchedulePageStateViewGroup = ({ bookingSchedule }) => bookingSchedule.pageState.viewGroup;

export const selectBookingSchedulePageStateView = ({ bookingSchedule }) => ({
  viewGroup: bookingSchedule.pageState.viewGroup,
  filterStatus: bookingSchedule.pageState.filters.status || []
});

export const selectBookingScheduleAsignCarTab = ({ bookingSchedule }) => bookingSchedule.asignCarTab;
// Reducer
export default bookingScheduleSlice.reducer;
